import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import SchoolProjects from './components/SchoolProjects';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Nav />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <SchoolProjects />
      <Contact />
    </div>
  );
}

export default App;
